import React, { useMemo } from "react";
import { Pane } from "evergreen-ui";
import { AdminProductListProvider } from "./state/AdminProductListProvider";
import { TableView } from "../../common/tables/view/TableView";
import { TablePageHeader } from "../../common/tables/view/TablePageHeader";

export const AdminProductListPage = React.memo(() => {

    const emptyViewProps = useMemo(() => {
        return {
            primaryText: "No Shopify products found. Products will appear here once they are synced from Shopify.",
            secondaryText: "",
        };
    }, []);

    const errorViewProps = useMemo(() => {
        return {
            primaryText: "Failed to load products",
            secondaryText: "Refresh the page to try again",
        }
    }, []);

    return (
        <Pane height={"100%"} display={"flex"} flexDirection={"column"}>
            <TablePageHeader
                title={"Products"}
            />
            <AdminProductListProvider>
                <TableView
                    emptyViewProps={emptyViewProps}
                    errorViewProps={errorViewProps}
                />
            </AdminProductListProvider>
        </Pane>
    );
});
